import { PermissionCode } from "Services/Api/Users/Types"

export const FEATURE_ICONS: Record<string, string> = {
    "Training": "trainingIcon",
    "Phishing": "phishingIcon",
    "SAQ Compliance": "saqMenuIcon",
    "Scanning": "scanningMenuIcon"
}

export const FEATURE_PERMISSION_KEYS: Record<string, string[]> = {
    "Training": [PermissionCode.ViewDashboardMyResults, PermissionCode.ViewDashboardElearning, PermissionCode.VIEW_TRAINING_ASSIGNMENT_WIZARD],
    "Phishing": [PermissionCode.ViewPhishingManager, PermissionCode.ViewDashboardPhishing, PermissionCode.ViewPhishingTemplateManager],
    "SAQ Compliance": [PermissionCode.ViewDashboardSAQCompliance],
    "Scanning": [PermissionCode.ViewDashboardScanning]
}